import styles from "./popup.module.scss";
import Box from "@mui/material/Box";
import { useEffect, useState, useRef } from "react";
import { Slide } from "@mui/material";
import { svgImages } from "@/lib/svgImages";
import { createPortal } from "react-dom";

const style = {
  position: "absolute",
  bottom: "0",
  left: "0",
  // transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  // border: "2px solid transparent",
  // borderRadius: 4,
  boxShadow: 24,
  width: "100vw",
  // maxWidth:"700px",
  // maxHeight: "70vh",
  outline: "none",
  overflowY: "hidden",
  "@media (max-width: 576px)": {
    height: "80vh",
  },
};

const Popup = ({ title, subtitle, content, icon, setOpenCard, openCard }) => {
  const [open, setOpen] = useState(false);
  const modalRef = useRef(null);
  const previousActiveElement = useRef(null);

  useEffect(() => {
    setOpen(openCard);
  }, [openCard]);

  const handleClose = () => {
    setOpenCard(false);
    setOpen(false);
  };

  // Handle escape key press and focus management
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && open) {
        handleClose();
      }
    };

    if (open) {
      // Store the previously focused element
      previousActiveElement.current = document.activeElement;

      document.addEventListener("keydown", handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";

      // Focus the modal after a short delay to ensure it's rendered
      setTimeout(() => {
        if (modalRef.current) {
          modalRef.current.focus();
        }
      }, 100);
    } else {
      // Restore focus to the previously focused element
      if (previousActiveElement.current) {
        previousActiveElement.current.focus();
      }
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [open]);

  if (!open) {
    return null;
  }

  const modalContent = (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      onClick={handleClose}
      role="presentation"
    >
      <Slide in={open} timeout={600} direction="up">
        <Box
          ref={modalRef}
          sx={{
            ...style,
          }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="parent-modal-title"
          aria-describedby="parent-modal-description"
          tabIndex={-1}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`${styles["closeIcon"]}`} onClick={handleClose}>
            <div className={`${styles["iconContainer"]}`}>
              <span
                dangerouslySetInnerHTML={{ __html: svgImages.arrowRight }}
              />
            </div>
          </div>
          <div className={`${styles["popupContent"]}`}>
            <div className={`${styles["popupContentInner"]}`}>
              <div
                className={`${styles["featureIcon"]}`}
                dangerouslySetInnerHTML={{ __html: icon }}
              />
              <div className={`${styles["textContainer"]}`}>
                <h2
                  id="parent-modal-title"
                  className={`${styles["title"]} font-size-48`}
                >
                  {title}
                </h2>
                <div
                  id="parent-modal-description"
                  className={`${styles["subtitle"]} font-size-18`}
                >
                  {subtitle}
                </div>
                <div
                  className={`${styles["description"]} font-size-15 line-height-content`}
                  dangerouslySetInnerHTML={{ __html: content }}
                ></div>
              </div>
            </div>
          </div>
        </Box>
      </Slide>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default Popup;
